// defineAsyncComponent
import { createApp, defineAsyncComponent, ref } from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import Modals from './plugins/modals/index.js';
import SiteDrawer from './plugins/site-drawer/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
import CookiesBar from './components/cookies-bar/index.vue';
const MarqueeText = defineAsyncComponent(() => import('vue-marquee-text-component'));
import BgVideo from './components/bg-video/index.vue';
import BgImage from './components/bg-image/index.vue';
import Circles from './circles.vue';
// const AboutCarousel = defineAsyncComponent(() => import('./about-carousel.vue'));
import AboutCarousel from './about-carousel.vue';
import FadeLogos from './fade-logos.vue';
import SustainabilityCarousel from './sustainability-carousel.vue';
import Services from './services.vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import { viewportSize } from './imports/utils.js';
import Animations from './animations.js';

createApp({
    mixins: [Animations],
    components: {
        MarqueeText,
        CookiesBar,
        BgVideo,
        Circles,
        AboutCarousel,
        FadeLogos,
        SustainabilityCarousel,
        Services
    },
    setup() {
        const cookiesBar = ref(true);

        const scrollToY = (y) => {
            let element;
            const headerH = document.querySelector("header").offsetHeight - 40;

            if (y.includes("#") || y.includes(".")) {
                element = document.querySelector(y);
            }

            if (element) {
                y = element.offsetTop - headerH;
            }

            if (y === '100vh') {
                y = window.innerHeight - headerH;
            }

            window.scrollTo(0, y);
        }

        const scrollTop = ref(window.scrollY);
        const onScroll = () => {
            scrollTop.value = window.scrollY;
        }
        window.addEventListener("scroll", onScroll, { passive: true });

        const viewport = ref(viewportSize());
        const onResize = () => {
            viewport.value = viewportSize();
        }
        window.addEventListener("resize", onResize, { passive: true });

        return { cookiesBar, scrollToY, scrollTop, viewport };
    },
    created() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');
        // window.addEventListener("resize", this.onResize, { passive: true });
        // if (this.isDevice) document.querySelector("html").classList.add("device");
    },
    destroyed() {
        // window.removeEventListener("scroll", this.onScroll);
        // window.removeEventListener("resize", this.onResize);
    }
})
    .use(SiteDrawer)
    .use(Modals)
    .component('BgImage', BgImage)
    .mount('#app')